import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

export function initAnalytics() {
  if (!KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        // mask password fields only
        password: true,
      },
    },
    // Don't capture pageview automatically — we'll track route changes manually
    capture_pageview: false,
    // Respect DNT
    respect_dnt: true,
  });
}

export function identify(user) {
  if (!KEY || !user) return;
  posthog.identify(user.user_id || user._id || user.email, {
    email: user.email,
    name: user.name,
    role: user.role,
  });
}

export function resetIdentity() {
  if (!KEY) return;
  posthog.reset();
}

export function trackPage(path) {
  if (!KEY) return;
  posthog.capture("$pageview", { $current_url: path });
}

export function track(event, props = {}) {
  if (!KEY) return;
  posthog.capture(event, props);
}
